export const ROLE_TYPE_UDM = 'Unit Deployment Manager';
export const ROLE_TYPE_MED_STAFF = 'Medical Staff Member';
export const ROLE_TYPE_PATIENT = 'Patient';
export const ROLE_TYPE_COMMANDER = 'Commander';
